<!-- 填写情绪详情 -->
<template>
  <div>
    <div class="chat-card" v-for="(item, index) in emotionList" :key="'emotion' + index">
      <div class="chat-text">
        <div class="chat-flex">
          我感到
          <div>
            <PickerPopup v-if="isCanEdit" v-model="item.emotion" :columns="EmotionArr" @input="changeEmotion($event, index)">
              <div class="sleect-input">
                {{ item.emotion || '请选择' }}
                <img class="bottom-icon" src="@/assets/images/select_icon.png" alt="选择">
              </div>
            </PickerPopup>
            <div v-else>{{ item.emotion }}</div>
          </div>
          情绪
        </div>
        <div class="chat-p">
          我觉得
          <span class="emotion">{{item.emotion}}</span>
          情绪的意义是什么？我们为什么会拥有这样的情绪？
        </div>
        <input class="input" :disabled="!isCanEdit" v-model="item.significance" type="text" placeholder="在这里输入详细内容">
        <div class="chat-p">
          我是如何知道自己在经历
          <span class="emotion">{{ item.emotion }}</span>
          情绪的？
        </div>
        <input class="input" :disabled="!isCanEdit" v-model="item.howKnow" type="text" placeholder="在这里输入详细内容">
        <div class="chat-p">
          感到
          <span class="emotion">{{ item.emotion }}</span>
          情绪会让我如何行动？换句话说，我会如何处理这种情绪？？
        </div>
        <input class="input" :disabled="!isCanEdit" v-model="item.handle" type="text" placeholder="在这里输入详细内容">
      </div>
    </div>
    <div class="add-btn" v-if="isCanEdit" @click="addEmotion">+</div>
    <button class="confirm-btn" v-if="isCanEdit" @click="confirmFn">确定</button>
    <!-- <div class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>
import { Form } from '@/components';
import { EMOTION_ARR } from "@/consts";

const { PickerPopup } = Form;

export default {
  name: 'ChatEmotionDetails',
  props: {
    cardData: {
      type: Object,
      default() {
        return null;
      }
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  components: { PickerPopup },
  data() {
    return {
      emotionList: [],
      EmotionArr: EMOTION_ARR
    };
  },
  created() {
  },
  mounted() {
    this.getInitData()
  },
  methods: {
    getInitData() {
      if(this.isCanEdit) {
        let useData = this.cardData.step_data.instance_data[0].answer.val;
        this.EmotionArr = this.cardData.step_data.instance_data[0].answer.val.map(item => {
          return {
            label: item,
            value: item,
          }
        });
        const useDataList = useData.slice(0, 2).map(item => {
          return {
            emotion: item,
            significance: '',
            howKnow: '',
            handle: ''
          }
        })
        this.emotionList = useDataList;
        console.log(useDataList)
      } else {
        if(this.nextData?.step_data?.survey?.qstList[0].answer.val) {
          let useData = this.nextData.step_data.survey.qstList[0].answer.val;
          this.emotionList = useData;
        }
      }
    },
    addEmotion() {
      this.emotionList.push({
        emotion: '',
        significance: '',
        howKnow: '',
        handle: ''
      });
    },
    // 改变情绪
    changeEmotion(selectIndex, index) {
      this.emotionList[index].emotion = this.EmotionArr[selectIndex].label
    },
    // 提交数据
    confirmFn() {
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: {
                  val: this.emotionList
                },
              },
            ],
          },
        },
      };
      this.$emit('confirmFn', useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 342px;
  border-radius: 12px 12px 12px 0px;
  padding: 20px 18px 8px 20px;
  background: #E8E3FC;
  box-sizing: border-box;
  margin-bottom: 10px;

  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
    .chat-flex {
      display: flex;
      align-items: center;
      .sleect-input {
        width: 178px;
        height: 22px;
        line-height: 22px;
        border-radius: 6px;
        background: #ffffff;
        margin: 0 4px;
        padding: 0 10px;
        box-sizing: border-box;
        .bottom-icon {
          float: right;
          width: 12px;
          height: 12px;
          margin-top: 6px;
        }
      }
    }
    .chat-p {
      margin-top: 10px;
      .emotion {
        // width: 90px;
        // line-height: 18px;
        // display: inline-block;
        // text-align: center;
        // border-bottom: 1px solid #000;
      }
    }
    .input {
      margin-top: 4px;
      width: 294px;
      height: 23px;
      border-radius: 6px;
      background: rgba(255, 255, 255, 1);
      color: $text-color;
      padding: 4px;
      box-sizing: border-box;
      border: none;
      font-size: 12px;
      display: flex;
      align-items: center;

      &::placeholder {
        font-size: 10px;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.4);
      }
    }
  }

}
.confirm-btn {
  width: 76px;
  height: 25px;
  border-radius: 12px;
  background: #AD7EFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.23px;
  color: #fff;
  border: none;
  margin: 9px auto 0;
}
.add-btn {
  width: 338px;
  height: 42px;
  border-radius: 6px;
  background: #E8E3FC;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: #A383F1;
  padding-bottom: 6px;
  box-sizing: border-box;
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}
</style>
